import isMobile from "ismobilejs";

export const mobile = isMobile(window.navigator).any;
